import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VDeviceMixin from './mixin';
import uuidv4 from 'uuid/v4';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import isEqual from 'lodash/isEqual';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import ApiService from '../../../../../../services/apiService';
import { mapGetters } from 'vuex';
export default {
  name: 'CoreDtwinStateVirtualDeviceAggregateHealth',
  mixins: [VDeviceMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    lclModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    usage: {
      type: String,
      required: false,
      // is either used in the `state` or in the `device-type`
      default: 'state'
    },
    // the whole device-type object, which should include the parser
    // ONLY relevant, if embedded into the device-type info
    deviceTypeObject: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    // ONLY relevant, if embedded into the twin-state-edit
    twinModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      healthMetrics: [],
      // a UI-proxy for the switch, in order to catch changes and "abort" via a prompt
      // if the prompt is accepted, forward to the actual `extendedMode` attr
      triggerExtendedModeSwitch: false,
      switchToWizardMode: false,
      extendedMode: false,
      deviceTypeHealthConfig: null,
      deviceDriverHealthConfig: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    formIsValid: function formIsValid() {
      return true;
    },
    vDeviceHealthStates: function vDeviceHealthStates() {
      if (this.usage === 'state') {
        return this.otherStates.map(this.mapStateToUi);
      }

      return this.deviceTypeVariables();
    },
    virtualDeviceConfigStates: function virtualDeviceConfigStates() {
      if (this.usage === 'state') {
        return get(this.value, 'stateIds');
      }

      return get(this.value, 'stateKeys');
    },
    stateObjects: function stateObjects() {
      return this.vDeviceHealthStates;
    },
    // jsHeaderPreview() {
    //   return `function (${(this.selectedVirtualDeviceState || [])
    //     .map((s) => {
    //       return s.key;
    //     })
    //     .join(', ')}) {`;
    // },
    identifierRules: function identifierRules() {
      var _this = this;

      return [function (v) {
        return !!v && _this.metricIdentifierIsUnique(v) || _this.$i18n_t('DigitalTwin.VirtualDevice.state.health.identifierUnique');
      }];
    },
    publishValue: function publishValue() {
      var publish = {
        health: cloneDeep(this.healthMetrics)
      };

      if (this.usage === 'state') {
        var stateIds = (this.selectedVirtualDeviceState || []).map(function (s) {
          return s.id;
        }); // simply use twin-id of any other state

        publish.id = get(this.otherStates, '[0].dtwinId');
        publish.stateIds = stateIds;
      } else {
        var stateKeys = (this.selectedVirtualDeviceState || []).map(function (s) {
          return s.key;
        });
        publish.stateKeys = stateKeys;
      }

      return publish;
    },
    availableDurations: function availableDurations() {
      var _this2 = this;

      var baseTranslation = 'DigitalTwin.DigitalTwin.visualization.timeRanges.count';
      return [15, 30].map(function (min) {
        return {
          value: min * 60,
          text: _this2.$i18n_tc("".concat(baseTranslation, "Min"), min, {
            n: min
          })
        };
      }).concat([1, 3, 6, 12, 24].map(function (hour) {
        return {
          value: hour * 3600,
          text: _this2.$i18n_tc("".concat(baseTranslation, "Hour"), hour, {
            n: hour
          })
        };
      })).concat([2, 7, 14].map(function (day) {
        return {
          value: day * 86400,
          text: _this2.$i18n_tc("".concat(baseTranslation, "Day"), day, {
            n: day
          })
        };
      })).concat([1, 3, 6].map(function (mon) {
        return {
          value: mon * 30 * 86400,
          text: _this2.$i18n_tc("".concat(baseTranslation, "Month"), mon, {
            n: mon
          })
        };
      })).concat([{
        value: 365 * 86400,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.1Y')
      }]);
    },
    operatorSelect: function operatorSelect() {
      return [{
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.valueOlderThan'),
        value: 'VALUE_OLDER_THAN'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.equals'),
        value: 'EQUALS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.notEquals'),
        value: 'NOT_EQUALS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.greaterThan'),
        value: 'GREATER_THAN'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.lessThan'),
        value: 'LESS_THAN'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.contains'),
        value: 'CONTAINS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.notContains'),
        value: 'NOT_CONTAINS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.isNull'),
        value: 'IS_NULL'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.isNotNull'),
        value: 'IS_NOT_NULL'
      }];
    },
    stateIdentAttr: function stateIdentAttr() {
      // which "identifier" of the state-object shall be used?
      // in the device-type health-config it is just a template, so use the key here,
      // since obviously the final state-id at the corresponding VD does not yet exist at that point
      return this.usage === 'state' ? 'id' : 'key';
    },
    isDeviceDriverActive: function isDeviceDriverActive() {
      return !this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback');
    }
  }),
  watch: {
    triggerExtendedModeSwitch: function triggerExtendedModeSwitch() {
      if (!this.triggerExtendedModeSwitch) {
        // switching from extended-mode to wizard-mode
        // warn user, that the custom scripts will be lost
        this.switchToWizardMode = true;
        return;
      }

      this.doChangeExtendedMode();
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var deviceTypeId, deviceDriverId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.healthMetrics = cloneDeep(get(this.value, 'health') || []);
              this.extendedMode = this.healthMetrics.length > 0 && this.healthMetrics.find(function (metric) {
                return metric.wizard;
              }) === undefined;
              this.triggerExtendedModeSwitch = this.extendedMode;
              deviceTypeId = get(this.twinModel, 'data.virtualDevice.deviceTypeId');
              deviceDriverId = get(this.twinModel, 'data.virtualDevice.deviceDriverId');

              if (this.isDeviceDriverActive) {
                deviceDriverId = deviceDriverId || deviceTypeId;
                deviceTypeId = null;
              }

              _context.prev = 6;

              if (!deviceTypeId) {
                _context.next = 12;
                break;
              }

              _context.next = 10;
              return this.fetchDeviceTypeHealthConfig(deviceTypeId);

            case 10:
              _context.next = 15;
              break;

            case 12:
              if (!deviceDriverId) {
                _context.next = 15;
                break;
              }

              _context.next = 15;
              return this.fetchDeviceDriverHealthConfig(deviceDriverId);

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](6);
              console.error(_context.t0);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 17]]);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    fetchDeviceTypeHealthConfig: function () {
      var _fetchDeviceTypeHealthConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var config, confValue;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return ApiService.virtualDeviceGetDeviceTypeHealthConfig(id);

              case 2:
                config = _context2.sent;
                confValue = (config || {}).value;
                this.deviceTypeHealthConfig = confValue;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchDeviceTypeHealthConfig(_x) {
        return _fetchDeviceTypeHealthConfig.apply(this, arguments);
      }

      return fetchDeviceTypeHealthConfig;
    }(),
    fetchDeviceDriverHealthConfig: function () {
      var _fetchDeviceDriverHealthConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var config;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return ApiService.virtualDeviceGetDeviceDriverHealthConfig(id);

              case 2:
                config = _context3.sent;
                this.deviceDriverHealthConfig = config || {};

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchDeviceDriverHealthConfig(_x2) {
        return _fetchDeviceDriverHealthConfig.apply(this, arguments);
      }

      return fetchDeviceDriverHealthConfig;
    }(),
    doChangeExtendedMode: function doChangeExtendedMode() {
      this.switchToWizardMode = false;
      this.extendedMode = this.triggerExtendedModeSwitch;
      this.emitSelection();
    },
    mapStateToPersistRepresentation: function mapStateToPersistRepresentation(state) {
      if (this.usage === 'state') {
        return this.vDeviceHealthStates.find(function (s) {
          return s.id === state;
        });
      }

      return this.vDeviceHealthStates.find(function (s) {
        return s.key === state;
      });
    },
    createUniqueMetricKey: function createUniqueMetricKey(metric, index, count) {
      // for switching between extendedMode and wizard-mode,
      // try to keep the original identifier, if one was set
      metric.identifier = metric.identifier || "metric_".concat(index);

      if (!this.metricIdentifierIsUnique(metric.identifier)) {
        // first try with the maximum index; new metrics are added at position 0, so they may
        // overlap with the initial "metric_0"
        if (metric.identifier === "metric_".concat(index)) {
          metric.identifier = "metric_".concat(count - 1);
        }

        if (!this.metricIdentifierIsUnique(metric.identifier)) {
          // force unique identifier then
          metric.identifier = "".concat(metric.identifier).concat(uuidv4());
        }
      }
    },
    jsTransformerFromWizard: function jsTransformerFromWizard(metric, wiredStateObj) {
      var metricValueIsNumber = function metricValueIsNumber(value) {
        return !isNaN(parseFloat(value)) && "".concat(parseFloat(value)) === "".concat(value);
      }; // in order to easier switch back to the extended mode, update the JS-transformer properly as well


      switch (metric.operator) {
        case 'VALUE_OLDER_THAN':
          metric.jsTransformer = " return new Date() - new Date(params[\"".concat(wiredStateObj.key, "\"].time) < ").concat(metric.value * 1000);
          break;

        case 'EQUALS':
        case 'NOT_EQUALS':
          metric.jsTransformer = " return params[\"".concat(wiredStateObj.key, "\"].value ").concat(metric.operator === 'EQUALS' ? '=' : '!', "= \"").concat(metric.value, "\" ");
          break;

        case 'GREATER_THAN':
        case 'LESS_THAN':
          var compValue = metricValueIsNumber(metric.value) ? parseFloat(metric.value) : "'".concat(metric.value, "'");
          metric.jsTransformer = " return params[\"".concat(wiredStateObj.key, "\"].value ").concat(metric.operator === 'LESS_THAN' ? '<' : '>', " ").concat(compValue, " ");
          break;

        case 'CONTAINS':
        case 'NOT_CONTAINS':
          if (typeof metric.value === 'string' || typeof metric.value === 'number') {
            metric.jsTransformer = " return (\"\"+params[\"".concat(wiredStateObj.key, "\"].value).toLowerCase().indexOf((\"\"+").concat(metric.value, ").toLowerCase()) ").concat(metric.operator === 'NOT_CONTAINS' ? '<' : '>=', " 0 ");
          } else {
            metric.jsTransformer = " return (\"\"+params[\"".concat(wiredStateObj.key, "\"].value).find(v => (\"\"+v).toLowerCase() == (\"\"+").concat(metric.value, ").toLowerCase() ) ").concat(metric.operator === 'NOT_CONTAINS' ? '==' : '!=', " undefined ");
          }

          break;

        case 'IS_NULL':
        case 'IS_NOT_NULL':
          metric.jsTransformer = " return params[\"".concat(wiredStateObj.key, "\"].value ").concat(metric.operator === 'IS_NULL' ? '=' : '!', "= null");
          break;

        default:
          metric.jsTransformer = ' return true ';
          break;
      }

      metric.jsTransformer += " ? \"".concat(metric.description, "\" : false; ");
    },
    emitSelection: function emitSelection() {
      var _this3 = this;

      var newVirtualDeviceState = this.selectedVirtualDeviceState;

      if (this.extendedMode !== true) {
        newVirtualDeviceState = [];
      }

      for (var i = this.healthMetrics.length - 1; i >= 0; i--) {
        var metric = this.healthMetrics[i];
        metric.wizard = this.extendedMode !== true;

        if (!this.extendedMode) {
          this.createUniqueMetricKey(metric, i, this.healthMetrics.length);

          if (metric.operator === 'VALUE_OLDER_THAN') {
            metric.wiredState = this.vDeviceHealthStates.find(function (s) {
              return s.key === '_raw';
            })[this.stateIdentAttr];
          } // push this state, if it does not exist yet in the final map


          var foundWiredStateObj = this.mapStateToPersistRepresentation(metric.wiredState);

          if (foundWiredStateObj) {
            newVirtualDeviceState.push(foundWiredStateObj);
          }

          var wiredStateObj = foundWiredStateObj || {};
          this.jsTransformerFromWizard(metric, wiredStateObj);
        } else {
          // in any case, also reset the wizard back to its default (empty) state
          // the user has been warned, that the config will be deleted
          metric.value = undefined;
          metric.operator = undefined;
          metric.key = undefined;
        }
      }

      if (!isEqual(newVirtualDeviceState, this.selectedVirtualDeviceState)) {
        // will trigger a re-call of emitSelection
        this.selectedVirtualDeviceState = newVirtualDeviceState;
        return;
      }

      var aggregateStateValue = {};
      this.selectedVirtualDeviceState.forEach(function (aggVar) {
        aggregateStateValue[aggVar.key] = aggVar.value;
      });
      this.aggregateStateValue = aggregateStateValue;
      this.$nextTick(function () {
        _this3.$emit('bridge-binding-changed', {
          config: _this3.publishValue,
          identifier: get(_this3.selectedVirtualDevice, 'id'),
          valueType: get(_this3.selectedVirtualDeviceState, '[0].properties.valueType'),
          variable: get(_this3.selectedVirtualDeviceState, '[0].key'),
          value: _this3.aggregateStateValue
        });
      });
      return this.aggregateStateValue;
    },
    metricIdentifierIsUnique: function metricIdentifierIsUnique(identifier) {
      return this.healthMetrics.filter(function (m) {
        return m.identifier === identifier;
      }).length <= 1;
    },
    addMetric: function addMetric(index) {
      this.healthMetrics.splice(index, 0, {
        type: 'error',
        jsTransformer: 'return null;',
        wizard: this.extendedMode === true,
        operator: 'VALUE_OLDER_THAN'
      });
      this.emitSelection();
    },
    deleteMetric: function deleteMetric(index) {
      pullAt(this.healthMetrics, [index]);
      this.healthMetrics = cloneDeep(this.healthMetrics);
      this.emitSelection();
    },
    saveState: function saveState() {
      var _this4 = this;

      this.emitSelection();
      Object.keys(this.publishValue).forEach(function (key) {
        _this4.value[key] = _this4.publishValue[key];
      });
    },
    // if used in device-type, load device-type variables instead of states of the vdevice
    deviceTypeVariables: function deviceTypeVariables() {
      var _this5 = this;

      var deviceTypeObjectCopy = cloneDeep(this.deviceTypeObject);
      var parserVars = get(deviceTypeObjectCopy, 'parser.config.variables') || {};

      if (get(deviceTypeObjectCopy, 'parser.type') === 'multi') {
        parserVars = {};
        var parserKeys = Object.keys(get(deviceTypeObjectCopy, 'parser.config') || {}).filter(function (k) {
          return k !== '__switch';
        });
        parserKeys.forEach(function (pKey) {
          if (isObject(get(deviceTypeObjectCopy, "parser.config.".concat(pKey, ".variables")))) {
            parserVars = _objectSpread(_objectSpread({}, parserVars), get(deviceTypeObjectCopy, "parser.config.".concat(pKey, ".variables")) || {});
          }
        });
      }

      if (Object.keys(parserVars).length > 0) {
        parserVars['_raw'] = {
          value_type: {
            name: 'json'
          }
        };
      }
      /*
      ORIGIN: {
        "temperature": {
          "name": "temperature",
          "value_type": { // << MUST BE FILLED!
            "name": "°C"
          }
        }
      }
      TARGET: {
        "temperature": {
          "time": "2019-05-28T14:17:36.000Z",
          "value": 29.75,
          "value_type_name": "°C",
          "variable": "temperature"
        }
      } */


      Object.keys(parserVars).forEach(function (parserKey) {
        parserVars[parserKey].key = parserKey;
        parserVars[parserKey].value = {};
        parserVars[parserKey].properties = {};

        if (parserVars[parserKey]['value_type']) {
          parserVars[parserKey].properties.unit = parserVars[parserKey]['value_type']['name'];
        }
      });
      return Object.keys(parserVars).map(function (key) {
        return _this5.mapStateToUi(parserVars[key]);
      });
    },
    syncFromDeviceType: function syncFromDeviceType() {
      var _this6 = this;

      ApiService.virtualDeviceSyncHealthConfig(this, this.lclModel.dtwinId).then(function () {
        _this6.$emit('stateUpdated');
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
};